
export const OPEN_MODAL_INCOME_SECTION = "modalIncomeSection/OPEN_MODAL_INCOME_SECTION";
export const CLOSE_MODAL_INCOME_SECTION = "modalIncomeSection/CLOSE_MODAL_INCOME_SECTION";
